<template>
  <button @click="scrollToTop()" ref="totop" id="scrollToTopBtn" title="Ga naar boven">Naar Boven</button>
</template>

<script>

export default {
  name: 'ScrollToTop',
  components: {},
  data() {
    return {
    }
  },

  mounted() {
    let vue_instance = this;
    // Toon de knop als de gebruiker naar beneden heeft gescrold
    window.onscroll = function () {
      vue_instance.scrollFunction()
    };
  },

  methods: {
    scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        this.$refs.totop.style.display = "block";
      }
      else {
        this.$refs.totop.style.display = "none";
      }
    },

    // Scroll naar boven wanneer de knop wordt geklikt
    scrollToTop() {
      document.body.scrollTop = 0; // Voor oudere browsers
      document.documentElement.scrollTop = 0; // Voor moderne browsers
    }
  }
}
</script>

<style scoped>

#scrollToTopBtn {
  display: none; /* Verberg de knop standaard */
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 99;
  font-size: 16px;
  border: none;
  outline: none;
  background-color: #555;
  color: white;
  cursor: pointer;
  padding: 15px;
  border-radius: 4px;
}

#scrollToTopBtn:hover {
  background-color: #777;
}
</style>